/**
 * Client lists are fetched with POST, filters in the body: search text is PHI and URLs end up in
 * logs. Names are encrypted, so the API searches them through a blind index — see
 * docs/modules/people.md → "Client name search".
 */
export const clientSearchKeys = {
    CODE: 'CODE',
    NAME: 'NAME',
    /** Name or code. */
    ANY: 'ANY',
};

export const CLIENT_SEARCH_URL = '/client/search';
export const CLIENT_BASIC_SEARCH_URL = '/client/basic/info/search';

/**
 * Drops what a GET query string would have dropped (undefined, null, '', empty arrays). In a body
 * an empty `statuses` would mean "no status" and return nothing, instead of "any status".
 */
export const toSearchBody = (params = {}) =>
    Object.fromEntries(
        Object.entries(params).filter(([, v]) => v !== undefined && v !== null && v !== '' && !(Array.isArray(v) && !v.length))
    );
